import { render, staticRenderFns } from "./Subscribers.vue?vue&type=template&id=565f908a&"
import script from "./Subscribers.vue?vue&type=script&lang=js&"
export * from "./Subscribers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports